import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { SecureStorage } from "../storage/SecureStorage";
import { API_BASE, LOGIN_ENDPOINT } from "../config";
import { setAuthFromLogin } from "../api/Client";
import { fetchUserProfile } from "../api/User";   // 👈 nuevo helper
import "../styles/auth.css";

declare global {
  interface Window {
    google?: {
      accounts?: {
        id?: {
          initialize: (config: any) => void;
          renderButton: (el: HTMLElement, options: any) => void;
          prompt?: () => void;
        };
      };
    };
  }
}

/* Inline SVG icons */
const MailIcon: React.FC = () => (
  <svg viewBox="0 0 24 24">
    <path
      d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 4-8 5L4 8V6l8 5 8-5v2Z"
      fill="currentColor"
    />
  </svg>
);
const LockIcon: React.FC = () => (
  <svg viewBox="0 0 24 24">
    <path
      d="M17 8h-1V6a4 4 0 1 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-6 0V6a2 2 0 1 1 4 0v2h-4Z"
      fill="currentColor"
    />
  </svg>
);
const EyeIcon: React.FC<{ off?: boolean }> = ({ off }) =>
  off ? (
    <svg viewBox="0 0 24 24">
      <path
        d="M12 5C6 5 2 12 2 12s4 7 10 7 10-7 10-7S18 5 12 5Zm0 10a3 3 0 0 1-3-3 3 3 0 0 1 4.6-2.7l4-4A9.5 9.5 0 0 0 12 7c-5 0-9 5-9 5s4 5 9 5a9.5 9.5 0 0 0 4.3-1l-3.4-3.4A3 3 0 0 1 12 15Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24">
      <path
        d="M12 5c6 0 10 7 10 7s-4 7-10 7S2 12 2 12s4-7 10-7Zm0 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
        fill="currentColor"
      />
    </svg>
  );

export default function LoginPage({ onLoginSuccess }: { onLoginSuccess?: () => void }) {
  const location = useLocation();
  const [tab, setTab] = useState<'human' | 'move'>(
    () => new URLSearchParams(location.search).get("next") === "move" ? "move" : "human"
  );
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const loginDestination = tab === "move" ? "/move" : "/product";
  // Google login temporalmente desactivado.
  // const [googleError, setGoogleError] = useState<string | null>(null);
  // const [googleIdToken, setGoogleIdToken] = useState<string | null>(null);
  // const [showGoogleRegistration, setShowGoogleRegistration] = useState(false);
  // const [regNombre, setRegNombre] = useState("");
  // const [regApellidos, setRegApellidos] = useState("");
  // const [regTelefono, setRegTelefono] = useState("");
  // const [regFechaNacimiento, setRegFechaNacimiento] = useState("");
  // const [regCodigoPostal, setRegCodigoPostal] = useState("");
  // const [regDireccionPostal, setRegDireccionPostal] = useState("");
  // const [regDni, setRegDni] = useState("");
  // const [regTutorNombre, setRegTutorNombre] = useState("");
  // const [regTutorApellidos, setRegTutorApellidos] = useState("");
  // const [regTutorDni, setRegTutorDni] = useState("");
  // const [regIsMinor, setRegIsMinor] = useState(false);
  // const [regError, setRegError] = useState<string | null>(null);
  // const googleButtonRef = useRef<HTMLDivElement | null>(null);

  // ---- Google login temporalmente desactivado ----
  // function validateDni(value: string): string {
  //   const regex = /^(\d{8}[A-Z]|X\d{7}[A-Z])$/;
  //   if (!regex.test(value.trim())) {
  //     return "DNI invalido: debe tener 8 numeros y una letra mayuscula o X + 7 numeros + letra mayuscula";
  //   }
  //   return "";
  // }
  //
  // function validateCodigoPostal(value: string): string {
  //   const regex = /^40\d{3}$/;
  //   if (!regex.test(value.trim())) {
  //     return "El codigo postal debe pertenecer a la provincia de Segovia";
  //   }
  //   return "";
  // }
  //
  // function dateInputToDdmmyyyy(value: string): string {
  //   if (!value) return "";
  //   const [y, m, d] = value.split("-");
  //   if (!y || !m || !d) return "";
  //   return `${d}${m}${y}`;
  // }
  //
  // function handleFechaNacimientoChange(value: string) {
  //   setRegFechaNacimiento(value);
  //   if (!value) {
  //     setRegIsMinor(false);
  //     return;
  //   }
  //   const [y, m, d] = value.split("-").map(Number);
  //   const nacimiento = new Date(y, m - 1, d);
  //   const hoy = new Date();
  //   let edad = hoy.getFullYear() - nacimiento.getFullYear();
  //   const mes = hoy.getMonth() - nacimiento.getMonth();
  //   if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) edad--;
  //   setRegIsMinor(edad < 18);
  // }
  //
  // async function handleGoogleCredential(credential: string) {
  //   setGoogleError(null);
  //   setRegError(null);
  //   try {
  //     const res = await fetch(`${API_BASE}/api/mobile/login/google`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ idToken: credential }),
  //     });
  //     const data = await res.json().catch(() => ({}));
  //     if (res.status === 404 && data?.needsRegistration) {
  //       const prefill = data?.prefill || {};
  //       const fullName = String(prefill.fullName || "").trim();
  //       const nameParts = fullName ? fullName.split(/\s+/) : [];
  //       setRegNombre(prefill.givenName || nameParts[0] || "");
  //       setRegApellidos(prefill.familyName || nameParts.slice(1).join(" ") || "");
  //       setRegDireccionPostal("");
  //       setRegDni("");
  //       setRegCodigoPostal("");
  //       setRegFechaNacimiento("");
  //       setRegTelefono("");
  //       setRegTutorNombre("");
  //       setRegTutorApellidos("");
  //       setRegTutorDni("");
  //       setRegIsMinor(false);
  //       setGoogleIdToken(credential);
  //       setShowGoogleRegistration(true);
  //       return;
  //     }
  //     if (!res.ok) {
  //       throw new Error(data.error || "No se pudo iniciar sesion con Google");
  //     }
  //     const { accessToken, refreshToken, id } = data;
  //     if (!accessToken || !refreshToken || !id) {
  //       throw new Error("Respuesta invalida del servidor");
  //     }
  //     const fullUser = await fetchUserProfile(id);
  //     await setAuthFromLogin({ accessToken, refreshToken, ...fullUser });
  //     if (onLoginSuccess) await onLoginSuccess();
  //     navigate("/product");
  //   } catch (err: any) {
  //     setGoogleError(err.message || "No se pudo iniciar sesion con Google");
  //   }
  // }
  //
  // async function handleGoogleRegistrationSubmit() {
  //   setRegError(null);
  //   if (!googleIdToken) return;
  //   if (!regNombre.trim() || !regApellidos.trim()) {
  //     setRegError("Nombre y apellidos son obligatorios");
  //     return;
  //   }
  //   if (!regTelefono.trim()) {
  //     setRegError("Telefono es obligatorio");
  //     return;
  //   }
  //   if (!regFechaNacimiento) {
  //     setRegError("Fecha de nacimiento es obligatoria");
  //     return;
  //   }
  //   const codigoPostalErr = validateCodigoPostal(regCodigoPostal);
  //   if (codigoPostalErr) {
  //     setRegError(codigoPostalErr);
  //     return;
  //   }
  //   if (!regDireccionPostal.trim()) {
  //     setRegError("Direccion postal es obligatoria");
  //     return;
  //   }
  //   const dniErr = validateDni(regDni);
  //   if (dniErr) {
  //     setRegError(dniErr);
  //     return;
  //   }
  //   if (regIsMinor) {
  //     if (!regTutorNombre.trim() || !regTutorApellidos.trim() || !regTutorDni.trim()) {
  //       setRegError("Faltan datos del tutor");
  //       return;
  //     }
  //     const tutorErr = validateDni(regTutorDni);
  //     if (tutorErr) {
  //       setRegError(tutorErr);
  //       return;
  //     }
  //   }
  //
  //   const payload: Record<string, any> = {
  //     idToken: googleIdToken,
  //     nombre: regNombre.trim(),
  //     apellidos: regApellidos.trim(),
  //     telefono: regTelefono.trim(),
  //     fecha_nacimiento: dateInputToDdmmyyyy(regFechaNacimiento),
  //     codigoPostal: regCodigoPostal.trim(),
  //     direccionPostal: regDireccionPostal.trim(),
  //     dni: regDni.trim(),
  //   };
  //   if (regIsMinor) {
  //     payload.tutor_nombre = regTutorNombre.trim();
  //     payload.tutor_apellidos = regTutorApellidos.trim();
  //     payload.tutor_dni = regTutorDni.trim();
  //   }
  //
  //   try {
  //     const res = await fetch(`${API_BASE}/api/mobile/register/google`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });
  //     const data = await res.json().catch(() => ({}));
  //     if (!res.ok) {
  //       throw new Error(data.error || "No se pudo completar el registro");
  //     }
  //
  //     await handleGoogleCredential(googleIdToken);
  //     setShowGoogleRegistration(false);
  //   } catch (err: any) {
  //     setRegError(err.message || "No se pudo completar el registro");
  //   }
  // }

  async function loginTo(destination: "/product" | "/move") {
    setError(null);

    try {
      // 1. Login → obtener tokens + id usuario
      const res = await fetch(`${API_BASE}${LOGIN_ENDPOINT}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || "Error desconocido");
      }

      const data = await res.json();
      const { accessToken, refreshToken, id } = data;

      if (!accessToken || !refreshToken || !id) {
        throw new Error("Respuesta inválida del servidor");
      }

      // 2. Guardar tokens
      await SecureStorage.saveTokens(accessToken, refreshToken);

      // 3. Pedir perfil completo y guardar en storage
      const fullUser = await fetchUserProfile(id);

      // 4. Mantener en memoria para axios
      await setAuthFromLogin({ accessToken, refreshToken, ...fullUser });

      // 5. Notificar a App para mostrar tour si corresponde
      if (onLoginSuccess) await onLoginSuccess();
      // 6. Navegar
      navigate(destination);
    } catch (err: any) {
      setError(err.message || "No se pudo iniciar sesión");
    }
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    await loginTo(loginDestination);
  }


  // Google login temporalmente desactivado.
  // useEffect(() => {
  //   if (!GOOGLE_CLIENT_ID) return;
  //   if (!googleButtonRef.current) return;
  //
  //   const initGoogle = () => {
  //     if (!window.google?.accounts?.id) return;
  //     window.google.accounts.id.initialize({
  //       client_id: GOOGLE_CLIENT_ID,
  //       callback: (resp: any) => {
  //         if (resp?.credential) {
  //           handleGoogleCredential(resp.credential);
  //         }
  //       },
  //     });
  //     if (googleButtonRef.current) {
  //       googleButtonRef.current.innerHTML = "";
  //       window.google.accounts.id.renderButton(googleButtonRef.current, {
  //         theme: "outline",
  //         size: "large",
  //         shape: "pill",
  //         width: "280",
  //         text: "signin_with",
  //       });
  //     }
  //   };
  //
  //   const existing = document.querySelector('script[data-google-identity="true"]');
  //   if (!existing) {
  //     const script = document.createElement("script");
  //     script.src = "https://accounts.google.com/gsi/client";
  //     script.async = true;
  //     script.defer = true;
  //     script.setAttribute("data-google-identity", "true");
  //     script.onload = initGoogle;
  //     document.body.appendChild(script);
  //     return;
  //   }
  //
  //   initGoogle();
  // }, []);

  return (
    <>
      <div className="top-bar" />
      <div className="auth-page">
        <div className="auth-container">

          <div className="auth-tabs">
            <button
              type="button"
              className={`auth-tab ${tab === 'human' ? 'auth-tab-active' : ''}`}
              onClick={() => {
                setError(null);
                setTab('human');
              }}
            >
              Human
            </button>
            <button
              type="button"
              className={`auth-tab auth-tab-move ${tab === 'move' ? 'auth-tab-active auth-tab-move-active' : ''}`}
              onClick={() => {
                setError(null);
                setTab('move');
              }}
            >
              Human Move
            </button>
          </div>

          <h1 className="auth-title">
            {tab === 'move' ? 'Accede a Human Move' : 'Accede a tu cuenta'}
          </h1>
          <form onSubmit={handleSubmit} noValidate>
            <div className="input-wrap">
              <MailIcon />
              <input
                className="auth-input"
                type="email"
                placeholder="Correo electrónico"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="input-wrap">
              <LockIcon />
              <input
                className="auth-input"
                type={showPwd ? "text" : "password"}
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="toggle-eye"
                onClick={() => setShowPwd((s) => !s)}
                aria-label="Mostrar u ocultar contraseña"
              >
                <EyeIcon off={!showPwd} />
              </button>
            </div>
            {error && <p className="auth-error">{error}</p>}
            <button type="submit" className="auth-button" style={{ color: "#fff" }}>
              Iniciar sesión
            </button>
          </form>
          <p className="auth-link">
            <a onClick={() => navigate("/recover-password")}>¿Olvidaste tu contraseña?</a>
          </p>
          <p className="auth-link">
            ¿No tienes cuenta? <Link to="/register">Regístrate ya</Link>
          </p>

          {/* Move register tab disabled */}

        </div>
      </div>
      <div className="bottom-bar" />

      {/* {showGoogleRegistration && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 3000,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "1.5rem",
              width: "90%",
              maxWidth: 420,
            }}
          >
            <h3 style={{ marginTop: 0 }}>Completa tu registro</h3>
            <p style={{ marginTop: 0, fontSize: 13, color: "#666" }}>
              Necesitamos algunos datos adicionales para finalizar tu alta.
            </p>
            <label style={{ fontSize: 14 }}>Nombre</label>
            <input
              type="text"
              value={regNombre}
              onChange={(e) => setRegNombre(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            />
            <label style={{ fontSize: 14 }}>Apellidos</label>
            <input
              type="text"
              value={regApellidos}
              onChange={(e) => setRegApellidos(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            />
            <label style={{ fontSize: 14 }}>Telefono *</label>
            <input
              type="tel"
              value={regTelefono}
              onChange={(e) => setRegTelefono(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            />
            <label style={{ fontSize: 14 }}>Fecha de nacimiento *</label>
            <input
              type="date"
              value={regFechaNacimiento}
              onChange={(e) => handleFechaNacimientoChange(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            />
            <label style={{ fontSize: 14 }}>Codigo postal *</label>
            <input
              type="text"
              value={regCodigoPostal}
              onChange={(e) => setRegCodigoPostal(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            />
            <label style={{ fontSize: 14 }}>Direccion postal *</label>
            <input
              type="text"
              value={regDireccionPostal}
              onChange={(e) => setRegDireccionPostal(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            />
            <label style={{ fontSize: 14 }}>DNI *</label>
            <input
              type="text"
              value={regDni}
              onChange={(e) => setRegDni(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: regIsMinor ? "0.5rem" : "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "6px",
              }}
            />

            {regIsMinor && (
              <>
                <label style={{ fontSize: 14 }}>Nombre del tutor *</label>
                <input
                  type="text"
                  value={regTutorNombre}
                  onChange={(e) => setRegTutorNombre(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "0.5rem",
                    marginBottom: "0.75rem",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
                <label style={{ fontSize: 14 }}>Apellidos del tutor *</label>
                <input
                  type="text"
                  value={regTutorApellidos}
                  onChange={(e) => setRegTutorApellidos(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "0.5rem",
                    marginBottom: "0.75rem",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
                <label style={{ fontSize: 14 }}>DNI del tutor *</label>
                <input
                  type="text"
                  value={regTutorDni}
                  onChange={(e) => setRegTutorDni(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "0.5rem",
                    marginBottom: "0.75rem",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
              </>
            )}

            {regError && <p className="auth-error">{regError}</p>}
            <button
              onClick={handleGoogleRegistrationSubmit}
              style={{
                width: "100%",
                padding: "0.75rem",
                background: "#1976d2",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                marginTop: "0.5rem",
              }}
            >
              Guardar y continuar
            </button>
            <button
              onClick={() => {
                setShowGoogleRegistration(false);
                setGoogleIdToken(null);
              }}
              style={{
                width: "100%",
                padding: "0.75rem",
                background: "transparent",
                color: "#1976d2",
                border: "none",
                marginTop: "0.5rem",
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      )} */}
    </>
  );
}
